var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.334 6.667a2 2 0 0 1 2-2h9.333a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H3.334a2 2 0 0 1-2-2V6.667Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 14V3.333C10.667 2.597 10.07 2 9.334 2H6.667c-.736 0-1.333.597-1.333 1.333V14",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgBriefcase as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.33398 6.66675C1.33398 5.56218 2.22942 4.66675 3.33398 4.66675H12.6673C13.7719 4.66675 14.6673 5.56218 14.6673 6.66675V12.0001C14.6673 13.1047 13.7719 14.0001 12.6673 14.0001H3.33398C2.22941 14.0001 1.33398 13.1047 1.33398 12.0001V6.66675Z' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M10.6673 14V3.33333C10.6673 2.59695 10.0704 2 9.33398 2H6.66732C5.93094 2 5.33398 2.59695 5.33398 3.33333V14' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";